const rankItems = [
  {
    rank: 1,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    genre: '韩漫热血',
    heat: '98.7万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20style%20illustration%20with%20vibrant%20warm%20colors%20featuring%20a%20single%20character%20portrait%20in%20dynamic%20pose%2C%20clean%20simple%20background%20with%20soft%20cream%20tone%2C%20Japanese%20manga%20cover%20aesthetic%2C%20minimal%20text%20space%2C%20editorial%20quality&width=200&height=260&seq=rank-cover-01&orientation=portrait',
    color: 'bg-accent-500',
  },
  {
    rank: 2,
    title: '神之塔',
    author: 'SIU',
    genre: '韩漫奇幻',
    heat: '87.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20style%20illustration%20with%20vibrant%20warm%20colors%20featuring%20a%20single%20character%20portrait%20in%20dynamic%20pose%2C%20clean%20simple%20background%20with%20soft%20cream%20tone%2C%20Japanese%20manga%20cover%20aesthetic%2C%20minimal%20text%20space%2C%20editorial%20quality&width=200&height=260&seq=rank-cover-02&orientation=portrait',
    color: 'bg-primary-500',
  },
  {
    rank: 3,
    title: '全知读者视角',
    author: 'sing N song',
    genre: '韩漫穿越',
    heat: '76.1万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20style%20illustration%20with%20vibrant%20warm%20colors%20featuring%20a%20single%20character%20portrait%20in%20dynamic%20pose%2C%20clean%20simple%20background%20with%20soft%20cream%20tone%2C%20Japanese%20manga%20cover%20aesthetic%2C%20minimal%20text%20space%2C%20editorial%20quality&width=200&height=260&seq=rank-cover-03&orientation=portrait',
    color: 'bg-secondary-500',
  },
  {
    rank: 4,
    title: '斗破苍穹',
    author: '天蚕土豆 / 任翔',
    genre: '国漫玄幻',
    heat: '69.5万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20style%20illustration%20with%20vibrant%20warm%20colors%20featuring%20a%20single%20character%20portrait%20in%20dynamic%20pose%2C%20clean%20simple%20background%20with%20soft%20cream%20tone%2C%20Japanese%20manga%20cover%20aesthetic%2C%20minimal%20text%20space%2C%20editorial%20quality&width=200&height=260&seq=rank-cover-04&orientation=portrait',
    color: 'bg-accent-500',
  },
  {
    rank: 5,
    title: '咒术回战',
    author: '芥见下下',
    genre: '日漫战斗',
    heat: '63.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20style%20illustration%20with%20vibrant%20warm%20colors%20featuring%20a%20single%20character%20portrait%20in%20dynamic%20pose%2C%20clean%20simple%20background%20with%20soft%20cream%20tone%2C%20Japanese%20manga%20cover%20aesthetic%2C%20minimal%20text%20space%2C%20editorial%20quality&width=200&height=260&seq=rank-cover-05&orientation=portrait',
    color: 'bg-primary-500',
  },
  {
    rank: 6,
    title: '间谍过家家',
    author: '远藤达哉',
    genre: '日漫喜剧',
    heat: '58.9万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20style%20illustration%20with%20vibrant%20warm%20colors%20featuring%20a%20single%20character%20portrait%20in%20dynamic%20pose%2C%20clean%20simple%20background%20with%20soft%20cream%20tone%2C%20Japanese%20manga%20cover%20aesthetic%2C%20minimal%20text%20space%2C%20editorial%20quality&width=200&height=260&seq=rank-cover-06&orientation=portrait',
    color: 'bg-secondary-500',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">漫画热度排行榜</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            实时追踪韩漫推荐、日漫大全与国漫排行榜中<strong>最受欢迎</strong>的作品，发现大家正在追的好漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rankItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 border border-background-200/60 rounded-xl hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative flex-shrink-0">
                <div className="w-16 h-20 md:w-[72px] md:h-[92px] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    title={`${item.title} - 土豪漫画网热门漫画`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <div className={`absolute -top-2 -left-2 w-7 h-7 ${item.color} text-background-50 rounded-full flex items-center justify-center text-xs font-bold`}>
                  {item.rank}
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-serif font-semibold text-sm md:text-base text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.author}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.genre}
                  </span>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                    <i className="ri-fire-line mr-0.5"></i>{item.heat}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}